import { createContext, useContext } from "react";

export type SidebarTab = "Requests" | "Traces";
export const OPEN_TRACES_DRAWER_EVENT = "promptlayer:open-traces-drawer";
export const ADD_TRACES_STRUCTURED_FILTER_EVENT = "promptlayer:add-traces-structured-filter";
export const ADD_REQUESTS_STRUCTURED_FILTER_EVENT = "promptlayer:add-requests-structured-filter";

export interface AddStructuredFilterEventDetail {
  field: string;
  nestedKey: string;
  nestedKeyDisplay?: string;
  value: string;
  valueDisplay?: string;
}

export type AddTracesStructuredFilterEventDetail = AddStructuredFilterEventDetail;
export type AddRequestsStructuredFilterEventDetail = AddStructuredFilterEventDetail;

interface SidebarTabContextValue {
  activeTab: SidebarTab;
  setActiveTab: (tab: SidebarTab) => void;
}

export const SidebarTabContext = createContext<SidebarTabContextValue | null>(null);

export const useSidebarTab = () => useContext(SidebarTabContext);
